import { apiSlice } from '../../app/services/apiSlice';

const ADDON_URL = 'inventory/api/addon';

export const productsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addAddon: builder.mutation({
      query: (data) => ({
        url: `${ADDON_URL}`,
        method: 'POST',
        body: data,
      }),
    }),

    getAddons: builder.query({
      query: (params) => ({
        url: `${ADDON_URL}`,
        params,
      }),
      transformResponse: (responseData) => {
        return responseData?.objectData || [];
      },
    }),

    getAddonDetails: builder.query({
      query: (params) => ({
        url: `${ADDON_URL}/${params}`,
      }),
      transformResponse: (responseData) => {
        return responseData?.objectData || [];
      },
    }),

    deleteAddon: builder.mutation({
      query: (id) => ({
        url: `${ADDON_URL}/${id}`,
        method: 'DELETE',
        body: { id },
      }),
    }),

    updateAddon: builder.mutation({
      query: (data) => ({
        url: `${ADDON_URL}`,
        method: 'PUT',
        body: { ...data },
      }),
    }),

    reorderAddOns: builder.mutation({
      query: ({ data }) => ({
        url: `${ADDON_URL}/updateOrder`,
        method: 'POST',
        body: data,
      }),
    }),

    toggleAddonEnable: builder.mutation({
      query: ({ data }) => ({
        url: `${ADDON_URL}/toggle/enable`,
        method: 'POST',
        body: data,
      }),
    }),

    addAddonToAllProduct: builder.mutation({
      query: ({ data }) => ({
        url: `${ADDON_URL}/toggle/addToAllProducts`,
        method: 'POST',
        body: data,
      }),
    }),

  }),
});

export const {
  useAddAddonMutation,
  useGetAddonsQuery,
  useDeleteAddonMutation,
  useUpdateAddonMutation,
  useGetAddonDetailsQuery,
  useReorderAddOnsMutation,
  useToggleAddonEnableMutation,
  useAddAddonToAllProductMutation
} = productsApiSlice;
